import React, { useEffect } from "react";
import { useGetAnalystServiceTouchPointsQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";

const ServiceTouchPoints = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["tiers", "clients"]);
    }, []);
    const customCellRender = {
        service_contribution: (row) => {
            return row?.service_contribution + "%";
        },
    };

    return (
        <div className="overflow-auto">
            <PaginatedDataTable
                queryHook={useGetAnalystServiceTouchPointsQuery}
                initialDateRange={dateRange}
                totalText="All Report Total"
                firstColumnWidth="200px"
                isColumnSticky={true}
                stickyColumnsCount={1}
                appliedFilters={appliedFilters}
                customCellRender={customCellRender}
            />
        </div>
    );
};

export default ServiceTouchPoints;
